// extracted by mini-css-extract-plugin
export default {"number":"number--sP0Dd","divider":"divider--QKOIu"};